/*
 * Copyright (c) 2021 CalAmp Corp. All Rights Reserved
*/
import React, {forwardRef} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {FormTextField} from '@ion/dls/src/components/forms/FormTextField';

export interface PhoneNumberInputProps {
  disabled: boolean;
  phoneNumber: string;
  onChange?: Function;
  autoComplete?: string;
  required?: boolean;
  placeholderText?: string;
  errorText?: boolean;
  hasError?: boolean;
  onBlur?: Function;
}

export const PhoneNumberInput = ({
  placeholderText,
  onChange,
  phoneNumber,
  required,
  disabled = false,
  ...props
}: PhoneNumberInputProps, ref) => {
  return (
    <FormTextField required={required}
      inputRef={ref}
      placeholder={placeholderText || translate('contacts:phone.placeholder.phone')}
      name={translate('contacts:phone.phoneNumber')}
      onChange={onChange}
      inputProps={{
        type : 'tel'
      }}
      defaultValue={phoneNumber}
      disabled={disabled}
      {...props} />
  );
};

export default forwardRef(PhoneNumberInput);
